import React, {Component, createRef} from 'react'
import {connect} from 'react-redux'
import Footer from './footer'
import Header from './header'
import MaintenanceCheck from './MaintenanceCheck'
import Message from './header/Message'
import {Col, Container} from '@amzn/stencil-react-components/layout'

class ApplicationLayout extends Component {
  constructor(props) {
    super(props);
    this.contentTop = createRef();
  }

  render() {
    const {messages} = this.props;

    return (
      <Container>
        <Col margin={{left: "S300", right: "S300"}} gridGap="S400">
          <MaintenanceCheck/>
          <Header/>
          {messages.filter(msg => !msg.data?.dismissed).map((message) => (
            <Message key={message.id} message={message} defaultFocus={this.contentTop}/>
          ))}
          <div ref={this.contentTop}/>
          {this.props.children}
          <Footer/>
        </Col>
      </Container>
    )
  }
}

const mapState = state => ({
  messages: state.flashMessage.messages
});

export default connect(mapState)(ApplicationLayout)
